
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/fiches-activites",
      function () {
        return require("private-next-pages/fiches-activites.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/fiches-activites"])
      });
    }
  